/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Features_Audio_DescInputs */

const en_fc_home_features_audio_desc = /** @type {(inputs: Fc_Home_Features_Audio_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EBU R128 loudness meters, a clip mixer with automation and native DSP effects for dialogue and music.`)
};

/**
* | output |
* | --- |
* | "EBU R128 loudness meters, a clip mixer with automation and native DSP effects for dialogue and music." |
*
* @param {Fc_Home_Features_Audio_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_features_audio_desc = /** @type {((inputs?: Fc_Home_Features_Audio_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Features_Audio_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_features_audio_desc(inputs)
});
export { fc_home_features_audio_desc as "fc.home.features.audio.desc" }